import { Decoration, DecorationSet } from 'prosemirror-view';
import { Node } from 'prosemirror-model';

function renderColor(issue) {
	const icon = document.createElement('div');

	icon.className = 'decoration-color';
	icon.title = issue[0];
	icon.style.setProperty(`--color`, `${issue[0]}`);
	icon.issue = issue;

	return icon;
}

function renderUrl(issue) {
	const icon = document.createElement('a');
	let url = new URL(issue[0]);
	let domain = url.origin;
	icon.className = 'decoration-email';
	icon.href = issue[0];
	icon.target = '_blank';
	icon.style.setProperty('background-image', `url(${domain}/favicon.ico)`);
	icon.issue = issue;

	return icon;
}

export default function(doc) {
	//const emailRegex = /(#[0-9a-f]{3,6})\b/gi;

	const emailRegex = /(\S+@.+\.\S+)\b/gi;
	const hexRegex = /(#[0-9a-f]{3,8})\b/gi;

	const lineRegex = /(^- )/gim;
	const headerRegex = /(^[#]+ )/gim;

	const urlRegex = /((\w+:\/\/)[-a-zA-Z0-9:@;?&=\/%\+\.\*!'\(\),\$_\{\}\^~\[\]`#|]+)/gi;
	const iso8601 = /^(\d{4})(-(\d{2}))??(-(\d{2}))??(T(\d{2}):(\d{2})(:(\d{2}))??(\.(\d+))??(([\+\-]{1}\d{2}:\d{2})|Z)??)??$/gi;

	const decorations = [];

	doc.descendants((node, position) => {
		if (!node.text) {
			return;
		}

		Array.from(node.text.matchAll(iso8601)).forEach(match => {
			const color = match[0];
			const index = match.index || 0;
			const from = position + index;
			const to = from + color.length;
			const decoration = Decoration.widget(from, renderColor(match));

			decorations.push(decoration);
		});

		Array.from(node.text.matchAll(hexRegex)).forEach(match => {
			const color = match[0];
			const index = match.index || 0;
			const from = position + index;
			const to = from + color.length;
			const decoration = Decoration.widget(from, renderColor(match));

			decorations.push(decoration);
		});

		Array.from(node.text.matchAll(urlRegex)).forEach(match => {
			const email = match[0];
			const index = match.index || 0;
			const from = position + index;
			const to = from + email.length;
			const decoration = Decoration.widget(from, renderUrl(match));

			decorations.push(decoration);
		});

		Array.from(node.text.matchAll(lineRegex)).forEach(match => {
			const email = match[0];
			const index = match.index || 0;
			const from = position + index;
			const to = from + email.length;
			const decoration = Decoration.inline(from, to, {
				class: 'text-line',
				style: `color:var(--p3)`
			});

			decorations.push(decoration);
		});

		Array.from(node.text.matchAll(headerRegex)).forEach(match => {
			const email = match[0];
			const index = match.index || 0;
			const from = position + index;
			const to = from + email.length;
			const decoration = Decoration.inline(from, to, {
				class: 'text-header',
				style: `color:var(--p3)`
			});

			decorations.push(decoration);
		});
	});

	return DecorationSet.create(doc, decorations);
}
